import React from 'react';
import { ApplicationView } from '@aha-app/mvc';

interface SelectionNameProps {
  color?: string;
  top?: number;
  left?: number;
  name: string;
}

export const SelectionName: React.FC<SelectionNameProps> = (props) => {
  const { color: backgroundColor, top, left, name } = props;

  return (
    <div
      style={{
        position: 'absolute',
        top,
        left,
        backgroundColor,
      }}
      className="aha-editor-v2__selection-name"
    >
      {name}
    </div>
  );
};

export default ApplicationView(SelectionName);
